import TurndownService from "turndown";

let turndown: TurndownService | null = null;

const getService = (): TurndownService => {
  if (turndown) return turndown;
  turndown = new TurndownService({
    headingStyle: "atx", // # H1, ## H2 etc.
    bulletListMarker: "-",
    codeBlockStyle: "fenced",
    emDelimiter: "*",
    strongDelimiter: "**",
    linkStyle: "inlined",
  });
  // Tables — turndown doesn't ship the GFM table plugin by default; do a
  // simple fallback that keeps cell text on separate lines so headings/rows
  // are still readable in plain text.
  turndown.addRule("tableRow", {
    filter: ["tr"],
    replacement: (content) => `${content.trim()}\n`,
  });
  turndown.addRule("tableCell", {
    filter: ["td", "th"],
    replacement: (content) => `${content.trim()} | `,
  });
  return turndown;
};

/**
 * Convert HTML produced by the JuriCloud generator to a markdown-ish text
 * representation that's readable in a plain textarea while preserving headings,
 * paragraphs, lists, and emphasis.
 */
export const htmlToMarkdown = (html: string): string => {
  if (!html) return "";
  // If the input doesn't look like HTML, return as-is.
  if (!/<[a-z][\s\S]*>/i.test(html)) return html.trim();
  try {
    const md = getService().turndown(html).trim();
    // Tighten up runs of blank lines that turndown sometimes leaves.
    return md.replace(/\n{3,}/g, "\n\n");
  } catch {
    // Last-resort fallback: strip tags.
    return html
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/<\/(p|div|li|h[1-6]|tr|br)>/gi, "\n")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .trim();
  }
};
